import { deleteProperty } from "@/services/helpers";

export const setUser = (state, payload) => {
  // this is watched and updates local storage
  state.user = payload;
  state.loggedIn = true;
  state.userDataReady = true;
  state.permissions = payload.permissions;
  state.featureFlags = payload.feature_flags || [];
  state.kioskPermissions = payload.kiosk_permissions || [];
  // state.kioskUser = {};
};

export const logout = (state, payload) => {
  // this is watched and updates local storage
  state.user = {};
  state.loggedIn = false;
  state.userDataReady = false;
  state.permissions = [];
  state.featureFlags = [];
  state.kioskUser = {};
  state.kioskPermissions = [];
};

export const setUserNotReady = (state, payload) => {
  state.userDataReady = false;
};

export const impersonate = (state, payload) => {
  // this is watched and updates local storage
  if (!state.kioskUser.id) {
    state.userDataReady = false;
    state.kioskUser = state.user;
    const originalKioskPermissions = state.kioskPermissions;

    state.user = payload;
    state.permissions = payload.permissions;
    state.featureFlags = payload.feature_flags || [];
    state.kioskPermissions = originalKioskPermissions; // Keep kiosk permissions during impersonation
  } else {
    state.user = payload;
    state.permissions = payload.permissions;
    state.featureFlags = payload.feature_flags || [];
  }
};

export const initInvitations = (state, payload) => {
  state.invitations = payload;
};

export const removeInvitation = (state, payload) => {
  state.invitations = deleteProperty(state.invitations, payload.toString());
};

export const updateUserCurrentCompanyId = (state, payload) => {
  state.user.current_company_id = payload;
};

export const updateUser = (state, payload) => {
  state.user = payload;
};

export const updateUserProfile = (state, payload) => {
  // this is watched and updates local storage
  state.user = payload;
  state.permissions = payload.permissions;
  state.featureFlags = payload.feature_flags || [];
  state.kioskPermissions = payload.kiosk_permissions || [];
};

export const updateUserPermissions = (state, payload) => {
  // this is watched and updates local storage
  state.permissions = payload;
};

export const stopImpersonating = (state, payload) => {
  // this is watched and updates local storage
  state.user = state.kioskUser;
  state.permissions = state.kioskUser.permissions || [];
  state.featureFlags = state.kioskUser.feature_flags || [];
  state.kioskPermissions = state.kioskUser.kiosk_permissions || [];

  state.kioskUser = {};
};
